/* v8 ignore start */

import { createNavigation } from 'next-intl/navigation';
import routing from './routing';

export const {
  getPathname,
  Link,
  redirect,
  // usePathname,
  // useRouter,
} = createNavigation(routing);
